export const TERMS_AGGREGATION_MISSING_VALUE_NAME = 'missing';
